angular.module('elidb').filter('links', function() {
    return function(string) {
    	if(!string) return;
        var output = string;
        var exp = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gim;
        //var exp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gim;
        var result = exp.exec(string);
        while(result) {
            output = output.replace(result[0], "<a href=\""+result[0]+"\" target=\"_blank\">"+result[0]+"</a>");
            result = exp.exec(string);
        }
        return output;
    };
});